var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4444 1.55556V3.11111H9.33333V1.55556H12.4444ZM4.66667 1.55556V6.22222H1.55556V1.55556H4.66667ZM12.4444 7.77778V12.4444H9.33333V7.77778H12.4444ZM4.66667 10.8889V12.4444H1.55556V10.8889H4.66667ZM14 0H7.77778V4.66667H14V0ZM6.22222 0H0V7.77778H6.22222V0ZM14 6.22222H7.77778V14H14V6.22222ZM6.22222 9.33333H0V14H6.22222V9.33333Z",
    fill: "#A4A4AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBtnIcon);
export default __webpack_public_path__ + "static/media/dashboardBtnIcon.96843a06cb0ff80b5d8b725f8ddb4ca1.svg";
export { ForwardRef as ReactComponent };